import React from "react";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import ErrorIcon from '@mui/icons-material/Error';
import DoneIcon from '@mui/icons-material/Done';
import { DataGrid } from '@mui/x-data-grid';
import { downloadCSV, CsvButton } from '../../../../service/CsvButton';
import Typography from '@mui/material/Typography';

const ExperimentBatchResults =(props)=>{

    const updated = props.experimentUpdated;
    const errors = props.experimentErrors;

    const getCsvExperimentsUpdated = (event) => {
        const fieldsHeader = updated.columns.filter((header)=> header.field !== 'id');
        const csvHeader = fieldsHeader.map((header) => ({label: header.headerName, key: header.field}));
        downloadCSV(updated.rows,csvHeader,"experiments_updated_list.csv");
    }

    const getCsvExperimentsFailed = (event) => {
        const fieldsheader = errors.columns.filter((header)=> header.field !== 'id');
        const csvHeader = fieldsheader.map((header) => ({label: header.headerName, key: header.field}));
        downloadCSV(errors.rows,csvHeader,"experiments_errors_list.csv");
    }

    return(
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
            <Grid item xs={6}>
                { updated.rows.length > 0 ?
                    <div style={{ height: 600, width: '100%' }}>
                        <Typography variant={"h6"} style={{color: 'green'}}> Experiments succesfully updated <DoneIcon/></Typography>
                        <DataGrid
                            rows={updated.rows}
                            columns={updated.columns}
                            pageSize={props.pageSize}
                            rowsPerPageOptions={[props.pageSize]}
                        />
                        <CsvButton getCsvData={getCsvExperimentsUpdated} />
                    </div>
                :
                    null
                }
            </Grid> 
            <Grid item xs={6}>
                { errors.rows.length > 0 ?
                    <Box
                        sx={{ 
                            height: 600,
                            width: '100%',
                            '& .red-reason': { color: 'red',},
                        }}
                    >
                        <Typography variant={"h6"} style={{color: 'red'}}> Experiments failed <ErrorIcon/></Typography>
                        <DataGrid
                            rows={errors.rows}
                            columns={errors.columns}
                            pageSize={props.pageSize}
                            rowsPerPageOptions={[props.pageSize]}
                        />
                        <CsvButton getCsvData={getCsvExperimentsFailed} />
                    </Box>                   
                :
                    null   
                }
            </Grid>
        </Grid>
    );

}

export default ExperimentBatchResults;